import { PatientDemographicSection } from '@data'
import { usePatientDemography } from '@hook'
import { Box, Skeleton, Text } from 'grommet'

function DetailSection({ section, isLoading }: { section: PatientDemographicSection; isLoading: boolean }) {
  return (
    <Box
      background="white"
      border={{ color: '#E5E7EB', size: '1px' }}
      className="rounded-lg"
      gap="medium"
      pad={{ horizontal: '24px', vertical: '24px' }}
    >
      <Text color="#111827" size="18px" weight={700}>
        {section.title}
      </Text>

      <Box gap="medium">
        {isLoading ? (
          Array.from({ length: 3 }).map((_, i) => (
            <Box align="start" direction="row" gap="medium" justify="between" key={i}>
              <Skeleton height="14px" width="40%" />
              <Skeleton height="14px" width="40%" />
            </Box>
          ))
        ) : section.items.length === 0 ? (
          <Text color="#7A7A7A" size="14px">
            No info to show
          </Text>
        ) : (
          section.items.map(item => (
            <Box align="start" direction="row" gap="medium" justify="between" key={`${section.title}-${item.label}`}>
              <Text color="#7A7A7A" size="14px">
                {item.label}
              </Text>
              <Text color={item.status === 'success' ? '#16A000' : '#292D32'} size="14px" textAlign="end" weight={400}>
                {item.value}
              </Text>
            </Box>
          ))
        )}
      </Box>
    </Box>
  )
}

export default function Demographics() {
  const { sections, isLoading } = usePatientDemography()

  const defaultTitles = ['Personal Details', 'Employment', 'Emergency Contact', 'MISC', 'Choices', 'Contact Details']

  let sectionsToRender: PatientDemographicSection[] = []
  if (sections && sections.length > 0) {
    sectionsToRender = sections
  } else {
    sectionsToRender = defaultTitles.map(title => ({ title, items: [] }))
  }

  return (
    <div className="grid grid-cols-1 gap-5 xl:grid-cols-2">
      {sectionsToRender.map(section => (
        <DetailSection isLoading={isLoading} key={section.title} section={section} />
      ))}
    </div>
  )
}
